import React from 'react';
import { motion } from 'framer-motion';
import { TRUST_ITEMS } from './offerData';

const OfferTrust: React.FC = () => (
  <section className="section-spacing bg-canvas border-t border-line">
    <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
      <motion.div
        className="text-center mb-10"
        initial={{ opacity: 0, y: 16 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, amount: 0.4 }}
        transition={{ duration: 0.45, ease: 'easeOut' }}
      >
        <span className="inline-flex items-center gap-2 rounded-full border border-accent/35 bg-accent-strong/10 px-4 py-1.5 text-xs font-semibold tracking-wider text-accent-soft uppercase mb-4">
          Nos engagements
        </span>
        <h2 className="heading-section text-balance mb-3">
          Ce qu'on nous raconte souvent, et ce qu'on fait différemment
        </h2>
        <p className="section-intro">
          Beaucoup d'indépendants nous contactent après une mauvaise expérience avec un prestataire web. Voici les situations qui reviennent le plus, et notre réponse.
        </p>
      </motion.div>

      <ul className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
        {TRUST_ITEMS.map(({ problem, commitment, icon: Icon }, index) => (
          <motion.li
            key={problem}
            className="flex flex-col rounded-2xl border border-line-strong bg-white/5 p-5 md:p-6"
            initial={{ opacity: 0, y: 18 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, amount: 0.3 }}
            transition={{ duration: 0.4, ease: 'easeOut', delay: index * 0.05 }}
          >
            <div className="mb-4 flex h-10 w-10 items-center justify-center rounded-lg bg-accent-strong/20">
              <Icon className="h-5 w-5 text-accent-soft" aria-hidden="true" />
            </div>
            <p className="text-xs uppercase tracking-wider text-fg-muted mb-1">Situation fréquente</p>
            <p className="italic text-fg mb-4">{`«\u00a0${problem}\u00a0»`}</p>
            <p className="text-xs uppercase tracking-wider text-accent-soft mb-1 mt-auto">Notre engagement</p>
            <p className="text-fg font-medium">{commitment}</p>
          </motion.li>
        ))}
      </ul>
    </div>
  </section>
);

export default OfferTrust;
